import { render, staticRenderFns } from "./index.vue?vue&type=template&id=238fef4a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=238fef4a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238fef4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('238fef4a')) {
      api.createRecord('238fef4a', component.options)
    } else {
      api.reload('238fef4a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=238fef4a&scoped=true", function () {
      api.rerender('238fef4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Advantages/index.vue"
export default component.exports